module.exports = __webpack_public_path__ + "f34c869befd7eeef7e1cd1ba135a100a.png";